import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
} from '@cradua/data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectReferencesService } from '../../services/project-references.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';

@Component({
  selector: 'mrsoftapps-project-report',
  templateUrl: './project-report.component.html',
  styleUrls: ['./project-report.component.scss'],
  animations: [fadeInAnimation],
  host: { '[@fadeInAnimation]': '' },
})
export class ProjectReportComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: GMOUDto;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() gmous: GMOUDto[];
  @Input() currencies: CurrencyDto[];
  @Output() changeEmit = new EventEmitter<any>();
  @Output() onActivityEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteEvent = new EventEmitter<any>();

  projectForm: FormGroup;
  selectedGmous: any;
  GmouData: GMOUDto;
  status = false;
  date = new Date();
  users = [
    { id: 1, name: 'Elvis Steve' },
    { id: 2, name: 'Julius Oko' },
  ];
  selectedProjects: ProjectDto[] | any[];
  genericFieldLabel: string;
  genericBlockLabel: string;
  GMOUName: string;
  totalAmount: any;
  constructor(
    private fb: FormBuilder,
    private projectRefService: ProjectReferencesService,
    public matDialog: MatDialog
  ) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.filterProjectModal();
  }

  filterProjectModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '30%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'reportSelectOptions',
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      gmous: this.gmous,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.selectGMOU(result.gmouId);
      }
    });
  }

  selectProjectType(event) {
    this.selectedGmous = this.gmous.filter(
      (item) => item.GMOUTypeId === event.value
    );
  }

  selectGMOU(id: string) {
    const gmoutItem: GMOUDto = this.gmous.find((item) => item.id === id);
    const foundProject: ProjectDto[] = this.projectManagements.filter(
      (item) => item.GMOUId === gmoutItem.id
    );
    if (foundProject) {
      this.GMOUName = gmoutItem.GMOUTitle;
      this.selectedProjects = foundProject.map((value) => {
        return {
          id: value.id,
          ProjectTitle: value.ProjectTitle,
          Description: value.Description,
          GMOUCategoryId: this.projectRefService.projectCategoryName(
            this.projectCategories,
            value.GMOUCategoryId
          ),
          GMOUTypeId: this.projectRefService.projectTypeName(
            this.projectTypes,
            value.GMOUTypeId
          ),
          Lgas: this.projectRefService.getLgaArray(this.lgas, value.LGAId),
          States: this.projectRefService.getStateArray(
            this.states,
            value.StateId
          ),
          OilBlocks: this.projectRefService.getOilBlockArray(
            this.oilBlocks,
            value.OilBlocId
          ),
          OilFields: this.projectRefService.getOilFieldArray(
            this.oilFields,
            value.OilFieldId
          ),
          Currency: this.projectRefService.currencyName(
            this.currencies,
            value.CurrencyId
          ),
          Budget: value.Budget,
          EndDate: value.EndDate,
          StartDate: value.StartDate,
          Executor: value.Executor,
          GMOUId: value.GMOUId,
        };
      });

      this.totalAmount = this.selectedProjects
        .map((item) => item.Budget)
        .reduce((prev, next) => prev + next);

      if (this.oilFields.length > 0) {
        this.genericFieldLabel = this.oilFields[0].LabelName;
        this.genericBlockLabel = this.oilBlocks[0].LabelName;
      }
      this.status = true;
    }
  }

  getState(id) {
    const selectedLga = this.lgas.find((item) => item.id === id);

    if (!selectedLga) {
      return;
    }

    const selectedState = this.states.find(
      (item) => item.id === selectedLga.StateId
    );

    if (!selectedState) {
      return;
    }

    return selectedState;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  getOilBlock(id) {
    const selectedOilField = this.oilFields.find((item) => item.id === id);
    if (!selectedOilField) {
      return;
    }

    const selectedOilBlock = this.oilBlocks.find(
      (item) => item.id === selectedOilField.OilBlockId
    );

    if (!selectedOilBlock) {
      return;
    }

    return selectedOilBlock;
  }
}
